/**
 * Telas da área logada (painel, chat, FidexaHub) carregadas sob demanda.
 *
 * Antes elas eram importadas direto no `router.tsx` e iam inteiras no bundle
 * principal: a home pública baixava o painel todo (chat v2, emoji-picker,
 * recharts, libphonenumber...), cerca de 1,4 MB de JS sem uso segundo o
 * Lighthouse. Os nomes são os mesmos dos componentes, então o JSX do router
 * não muda.
 *
 * O site público (home, LPs, legais, blog, /auth) continua no bundle
 * principal de propósito: o HTML dessas rotas é prerenderizado e o app monta
 * por cima dele sem esperar chunk (ver o comentário do blog no router).
 *
 * O `Suspense` destas telas fica no RootLayout (primeira carga) e no
 * DashboardLayout (navegação dentro do painel).
 */
import { lazyWithReload } from "@/utils/lazyWithReload";


export const BillingManagement = lazyWithReload(() =>
  import("@/pages/dashboard/billingManagement/billingManagement").then(m => ({ default: m.BillingManagement }))
);

export const CsatReport = lazyWithReload(() =>
  import("@/pages/dashboard/csatReport/csatReport").then(m => ({ default: m.CsatReport }))
);

export const Customers = lazyWithReload(() =>
  import("@/pages/customers/Customers").then(m => ({ default: m.Customers }))
);

export const Dashboard = lazyWithReload(() =>
  import("@/pages/dashboard/dashboard").then(m => ({ default: m.Dashboard }))
);

export const DashboardChangePassword = lazyWithReload(() =>
  import("@/pages/dashboard/dashboardChangePassword/dashboardChangePassword").then(m => ({ default: m.DashboardChangePassword }))
);

export const FidexaPayAccount = lazyWithReload(() =>
  import("@/pages/dashboard/fidexaPay/FidexaPayAccount").then(m => ({ default: m.FidexaPayAccount }))
);

export const FidexaPaySettings = lazyWithReload(() =>
  import("@/pages/dashboard/fidexaPay/FidexaPaySettings").then(m => ({ default: m.FidexaPaySettings }))
);

export const FidexaPayStatements = lazyWithReload(() =>
  import("@/pages/dashboard/fidexaPay/FidexaPayStatements").then(m => ({ default: m.FidexaPayStatements }))
);

export const FidexaPayWithdraw = lazyWithReload(() =>
  import("@/pages/dashboard/fidexaPay/FidexaPayWithdraw").then(m => ({ default: m.FidexaPayWithdraw }))
);

export const ImportSheets = lazyWithReload(() =>
  import("@/pages/importSheets/ImportSheets").then(m => ({ default: m.ImportSheets }))
);

export const ImportSheetsItems = lazyWithReload(() =>
  import("@/pages/importSheets/ImportSheetsItems").then(m => ({ default: m.ImportSheetsItems }))
);

export const MessageManager = lazyWithReload(() =>
  import("@/pages/dashboard/messageManager/messageManager").then(m => ({ default: m.MessageManager }))
);

export const ReceivablesPaid = lazyWithReload(() =>
  import("@/pages/dashboard/reports/receivablesPaid/receivablesPaid").then(m => ({ default: m.ReceivablesPaid }))
);

export const Roadmap = lazyWithReload(() =>
  import("@/pages/dashboard/roadmap/Roadmap").then(m => ({ default: m.Roadmap }))
);

export const ScheduledClients = lazyWithReload(() =>
  import("@/pages/dashboard/reports/scheduledClients/scheduledClients").then(m => ({ default: m.ScheduledClients }))
);

export const SendMessages = lazyWithReload(() =>
  import("@/pages/dashboard/reports/sendMessages/sendMessages").then(m => ({ default: m.SendMessages }))
);

export const Settings = lazyWithReload(() =>
  import("@/pages/dashboard/settings/settings").then(m => ({ default: m.Settings }))
);

export const Training = lazyWithReload(() =>
  import("@/pages/dashboard/training/training").then(m => ({ default: m.Training }))
);

export const TrainingDetail = lazyWithReload(() =>
  import("@/pages/dashboard/training/trainingDetail").then(m => ({ default: m.TrainingDetail }))
);

export const TrainingRanking = lazyWithReload(() =>
  import("@/pages/dashboard/training/trainingRanking").then(m => ({ default: m.TrainingRanking }))
);

export const UnresponsiveClients = lazyWithReload(() =>
  import("@/pages/dashboard/reports/unresponsiveClients/unresponsiveClients").then(m => ({ default: m.UnresponsiveClients }))
);

export const User = lazyWithReload(() =>
  import("@/pages/user/User").then(m => ({ default: m.User }))
);

export const BillingResultDetailPage = lazyWithReload(() =>
  import("@/pages/billingResults/BillingResultDetailPage").then(m => ({ default: m.BillingResultDetailPage }))
);

export const BillingResultsPage = lazyWithReload(() =>
  import("@/pages/billingResults/BillingResultsPage").then(m => ({ default: m.BillingResultsPage }))
);

export const BillingQueuePage = lazyWithReload(() =>
  import("@/pages/billingQueue/BillingQueuePage").then(m => ({ default: m.BillingQueuePage }))
);

export const CreditCustomerPage = lazyWithReload(() =>
  import("@/pages/creditCustomer/CreditCustomerPage").then(m => ({ default: m.CreditCustomerPage }))
);

export const FidexaNotificationPage = lazyWithReload(() =>
  import("@/pages/fidexaNotification/FidexaNotificationPage").then(m => ({ default: m.FidexaNotificationPage }))
);

export const CampaignResultDetailPage = lazyWithReload(() =>
  import("@/pages/campaigns/CampaignResultDetailPage").then(m => ({ default: m.CampaignResultDetailPage }))
);

export const CampaignResultsPage = lazyWithReload(() =>
  import("@/pages/campaigns/CampaignResultsPage").then(m => ({ default: m.CampaignResultsPage }))
);

export const CampaignsPage = lazyWithReload(() =>
  import("@/pages/campaigns/CampaignsPage").then(m => ({ default: m.CampaignsPage }))
);

export const NewCampaignPage = lazyWithReload(() =>
  import("@/pages/campaigns/NewCampaignPage").then(m => ({ default: m.NewCampaignPage }))
);

export const SheetTemplatesPage = lazyWithReload(() =>
  import("@/pages/campaigns/SheetTemplatesPage").then(m => ({ default: m.SheetTemplatesPage }))
);

export const MessageSuggestions = lazyWithReload(() =>
  import("@/pages/dashboard/messageSuggestions/messageSuggestions").then(m => ({ default: m.MessageSuggestions }))
);

export const HubChatPage = lazyWithReload(() =>
  import("@/pages/hub/chat").then(m => ({ default: m.HubChatPage }))
);

export const HubInvitePage = lazyWithReload(() =>
  import("@/pages/hub/invite").then(m => ({ default: m.HubInvitePage }))
);

export const HubCompanyInvitePage = lazyWithReload(() =>
  import("@/pages/hub/loja").then(m => ({ default: m.HubCompanyInvitePage }))
);

export const HubLinkPage = lazyWithReload(() =>
  import("@/pages/hub/link").then(m => ({ default: m.HubLinkPage }))
);

export const HubResumeCode = lazyWithReload(() =>
  import("@/pages/hub/resume/code").then(m => ({ default: m.HubResumeCode }))
);

export const HubResumePhone = lazyWithReload(() =>
  import("@/pages/hub/resume/phone").then(m => ({ default: m.HubResumePhone }))
);

export const ChatPage = lazyWithReload(() =>
  import("@/v2/pages/chat/ChatPage").then(m => ({ default: m.ChatPage }))
);

export const DashboardLayout = lazyWithReload(() =>
  import("@/components/layouts/dashboardLayout").then(m => ({ default: m.DashboardLayout }))
);

export const FidexaHubAuthLayout = lazyWithReload(() =>
  import("@/components/layouts/fidexaHubAuthLayout").then(m => ({ default: m.FidexaHubAuthLayout }))
);

export const FidexaHubProtectedRoute = lazyWithReload(() =>
  import("@/components/layouts/fidexaHubProtectedRoute").then(m => ({ default: m.FidexaHubProtectedRoute }))
);

export const ProtectedRoute = lazyWithReload(() =>
  import("@/components/layouts/protectedRoute").then(m => ({ default: m.ProtectedRoute }))
);
